// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__37B-f","col":"CardReaderDesc_col__d81UL","label":"CardReaderDesc_label__3_KX0"};